/**
 * Listen Prompt CSS Styles
 *
 * Injected when the prompt is first shown. Anchor edge and offsets are read
 * from the element at match time, so the sheet is static.
 */

/**
 * Generate CSS styles with a custom class prefix.
 *
 * @param prefix - CSS class prefix (default: "rv")
 */
export function generatePopupStyles(prefix = 'rv'): string {
  return `
.${prefix}ListenPrompt {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  height: 42px;
  padding: 0 15px 0 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  border: 0;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.72);
  color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.22);
  font-family: Arial, Helvetica, sans-serif;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.025em;
  text-transform: uppercase;
  cursor: pointer;
  z-index: 2147483647;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  opacity: 0;
  pointer-events: none;
  transition: opacity 180ms ease, background 180ms ease, box-shadow 180ms ease,
    padding 180ms ease, height 180ms ease;
}

.${prefix}ListenPrompt[data-rv-listen-edge='bottom'] {
  bottom: var(--${prefix}-listen-offset, 20px);
}

.${prefix}ListenPrompt[data-rv-listen-edge='top'] {
  top: var(--${prefix}-listen-offset, 20px);
}

.${prefix}ListenPrompt.is-visible {
  opacity: 1;
  pointer-events: auto;
}

.${prefix}ListenPrompt:hover {
  background: rgba(0, 0, 0, 0.82);
}

.${prefix}ListenPrompt:focus-visible {
  outline: 2px solid rgba(255, 255, 255, 0.85);
  outline-offset: 3px;
}

.${prefix}ListenPromptIcon {
  display: block;
  flex: 0 0 auto;
}

.${prefix}ListenPromptIcon svg {
  width: 23px;
  height: 23px;
  display: block;
  color: currentColor;
}

.${prefix}ListenPromptText {
  white-space: nowrap;
  line-height: 1;
}

.${prefix}ListenPrompt.is-collapsed {
  height: 34px;
  padding: 0;
  gap: 0;
  background: transparent;
  box-shadow: none;
}

.${prefix}ListenPrompt.is-collapsed:hover {
  background: transparent;
}

.${prefix}ListenPrompt.is-collapsed .${prefix}ListenPromptIcon svg {
  width: 30px;
  height: 30px;
  color: #fff;
  filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.75)) drop-shadow(0 2px 4px rgba(0, 0, 0, 0.45));
}

.${prefix}ListenPrompt.is-collapsed .${prefix}ListenPromptText {
  display: none;
}

@media (max-width: 520px) {
  .${prefix}ListenPrompt[data-rv-listen-edge='bottom'] {
    bottom: var(--${prefix}-listen-offset-mobile, 14px);
  }

  .${prefix}ListenPrompt[data-rv-listen-edge='top'] {
    top: var(--${prefix}-listen-offset-mobile, 14px);
  }
}`.trim();
}

/**
 * Default CSS styles for the listen prompt (rv prefix).
 * Pre-generated for zero-cost default path.
 */
export const POPUP_STYLES = generatePopupStyles('rv');

/**
 * Style element ID for cleanup
 */
export const POPUP_STYLE_ID = 'rv-permission-popup-styles';
